//@ts-nocheck
import React from "react";

import MDButton from "../../../components/MDButton";
import { Delete, Edit, Refresh, WidthFull } from "@mui/icons-material";
import MDBox from "../../../components/MDBox";
import MDTypography from "components/MDTypography";

export interface FileColumns {
  Header: string;
  accessor: string;
  width: number;
  minWidth?: number;
  maxWidth?: number;
  Cell?: React.FC<{ row: { original: any } }>;
}

const filesColumn: FileColumns[] = (
  handleDownloadFile: (media: any) => void,
  handleDeleteMediaAttachment: (media: any) => void,
  handleEditSelected: (selected: any) => void
) => [
  {
    Header: "NAME",
    accessor: "name",
    allowSelection: false,
    minWidth: 270,
    Cell: ({ row }) => {
      const media = row.original;
      return (
        <MDTypography
          component="a"
          href="#"
          fontSize="15px"
          onClick={(e) => {
            e.preventDefault();
            if (media) {
              handleDownloadFile(media);
            }
          }}
          sx={{
            textDecoration: "none",
            color: "inherit",
            "&:hover": {
              textDecoration: "underline",
              color: (theme) => theme.palette.info.main,
            },
            cursor: "pointer",
          }}
        >
          {media.name}
        </MDTypography>
      );
    },
  },
  {
    Header: "CATEGORY",
    accessor: "category",
  },
  {
    Header: "DESCRIPTION",
    accessor: "description",
    minWidth: 300,
  },
  {
    Header: "UPLOADED BY",
    accessor: "createdBy",
  },
  {
    Header: "Date",
    accessor: "updatedAt",
    width: 30,
    Cell: ({ row }) => {
      const dateString = row.original.updatedAt;

      if (!dateString) {
        return <span></span>;
      }

      const dateParts = dateString.split(" ")[0];

      if (!dateParts || dateParts.split("-").length !== 3) {
        return <span></span>;
      }

      const [year, month, day] = dateParts.split("-");

      const formattedDate = `${month}-${day}-${year.slice(-2)}`;

      return <span>{formattedDate}</span>;
    },
  },
  {
    Header: "Actions",
    accessor: "actions",
    minWidth: 60,
    Cell: ({ row }: any) => {
      return (
        <MDBox display={"flex"} justifyContent={"flex-start"}>
          <MDButton
            variant="text"
            color="error"
            onClick={() => {
              const media = row.original;
              handleDeleteMediaAttachment(media);
            }}
            startIcon={<Delete />}
          >
            Delete
          </MDButton>

          <MDButton
            variant="text"
            color="secondary"
            startIcon={<Edit />}
            onClick={() => {
              const media = row.original;
              handleEditSelected(media);
            }}
          >
            {" "}
            Edit
          </MDButton>
        </MDBox>
      );
    },
  },
];

export default filesColumn;
